var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"container external-page",attrs:{"id":"ifrList","name":"ifrList","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }